import apiClient from '../axios';

// 백엔드 DB 구조에 맞춰 Category 인터페이스 정의
export interface Category {
  id: string; // DB의 Long 타입 ID
  categoryNameEn: string; // 영문 카테고리명
  categoryNameKr: string; // 국문 카테고리명 (화면 노출용)
  categoryEmoji: string; // 이모지
}

/**
 * 카테고리 관련 API 모음
 */
const CATEGORY_URL = () => '/api/category'; // 백엔드 카테고리 API 엔드포인트에 맞춰 수정

export const categoryApi = {
  /**
   * 모든 카테고리 목록 조회 API
   */
  getCategories: async (): Promise<Category[]> => {
    // 백엔드 엔드포인트: /api/category/getCategories
    const response = await apiClient.get<{ results: Category[] }>(`${CATEGORY_URL()}/getCategories`);
    return response.data.results;
  },
};
